import React from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const CustomPhoneInput = ({
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder = "Enter phone number",
  country = "us",
  isValid,
  autoFormat = true,
  enableAreaCodes = true,
  enableSearch = true,
  containerStyle = {},
  inputStyle = {},
  disabled = false,
}) => {
  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
    >
      <PhoneInput
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        country={country}
        isValid={isValid}
        disabled={disabled}
        autoFormat={autoFormat}
        enableAreaCodes={enableAreaCodes}
        enableSearch={enableSearch}
        containerStyle={{ width: "100%", ...containerStyle }}
        inputStyle={{
          width: "100%",
          display: "block",
          height: "calc(1.5em + .75rem + 2px)",
          fontSize: "1rem",
          fontWeight: "400",
          lineHeight: "1.5",
          color: "#5e667b",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid #eee",
          borderRadius: ".25rem",
          transition:
            "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
          outline: "none",
          boxSizing: "border-box",
          ...inputStyle,
        }}
        inputProps={{
          onKeyDown: (e) => {
            e.stopPropagation();
          },
        }}
      />
    </div>
  );
};

CustomPhoneInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  country: PropTypes.string,
  isValid: PropTypes.func,
  autoFormat: PropTypes.bool,
  enableAreaCodes: PropTypes.bool,
  enableSearch: PropTypes.bool,
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  disabled: PropTypes.bool,
};

export default CustomPhoneInput;
